import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./core/services/store";
import ApiService from "./core/services/api.service";
import AuthApiService from "./core/services/authapi.service";
//import MockService from "./core/mock/mock.service";
//import { VERIFY_AUTH } from "./core/services/store/auth.module";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";

Vue.config.productionTip = false;

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;

// Vue 3rd party plugins
import i18n from "./core/plugins/vue-i18n";
import vuetify from "./core/plugins/vuetify";
import "./core/plugins/portal-vue";
import "./core/plugins/bootstrap-vue";
import "./core/plugins/perfect-scrollbar";
import "./core/plugins/highlight-js";
import "./core/plugins/inline-svg";
import "./core/plugins/apexcharts";
import "./core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";

//global css
import "./assets/css/global.css";

// Devextreme
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";

// Leaflet
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
import "leaflet-geosearch/dist/geosearch.css";

// vue-loading-overlay
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
Vue.use(Loading);

// API service init
ApiService.init();

// Auth API service init
AuthApiService.init();

// Remove this to disable mock API
//MockService.init();

//hub
import AvailabilityHub from "./availability.hub";
Vue.use(AvailabilityHub);

//Timeago
import VueTimeago from "vue-timeago";
Vue.use(VueTimeago, {
  name: "Timeago",
  locale: "fr",
  locales: {
    fr: require("date-fns/locale/fr"),
  },
});

//vue-moment
Vue.use(require("vue-moment"));

//Viewer
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
Vue.use(Viewer);

//vue-notification
import Notifications from "vue-notification";
Vue.use(Notifications);

// router.beforeEach((to, from, next) => {
//   // reset config to initial state
//   store.dispatch(RESET_LAYOUT_CONFIG);

//   // Ensure we checked auth before each page load.
//   Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);

//   // Scroll page to top on every route change
//   setTimeout(() => {
//     window.scrollTo(0, 0);
//   }, 100);
// });

router.beforeEach((to, from, next) => {
  // reset config to initial state
  store.dispatch(RESET_LAYOUT_CONFIG);

  if (to.meta.authRequired && !store.getters["isAuthenticated"])
    next({ path: "/login" });
  else next();

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
